import React from 'react'
import classnames from 'classnames'

interface PenEditIconProps {
  className?: string
}

const PenEditIcon: React.FC<PenEditIconProps> = ({ className = '' }) => {
  return (
    <svg
      className={classnames('icon--pen-edit', {
        [className]: !!className,
      })}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M19.1028 0.674041L19.0788 0.652085C18.6184 0.231598 18.0217 0 17.3985 0C16.6999 0 16.0291 0.295745 15.5581 0.811337L6.65247 10.5613C6.57129 10.6501 6.50972 10.755 6.47166 10.8691L5.42448 14.0084C5.30341 14.3713 5.36418 14.7727 5.587 15.082C5.81161 15.3938 6.17345 15.5799 6.55501 15.5799H6.55507C6.72011 15.5799 6.88143 15.546 7.03443 15.479L10.0664 14.1526C10.1766 14.1044 10.2755 14.0336 10.3567 13.9448L19.2624 4.1949C20.1891 3.1804 20.1176 1.60106 19.1028 0.674041ZM7.43084 13.4285L8.04532 11.5864L8.09714 11.5296L9.26178 12.5933L9.20996 12.6501L7.43084 13.4285ZM17.9926 3.03502L10.4217 11.3236L9.25702 10.2599L16.828 1.97122C16.976 1.8091 17.1787 1.71978 17.3986 1.71978C17.5915 1.71978 17.7763 1.79156 17.9192 1.92215L17.9433 1.9441C18.2576 2.23125 18.2798 2.72064 17.9926 3.03502Z"
        fill="currentColor"
      />
      <path
        d="M17.3752 7.9333C16.9003 7.9333 16.5153 8.3183 16.5153 8.79319V16.0935C16.5153 17.2993 15.5342 18.2803 14.3284 18.2803H3.9066C2.70075 18.2803 1.71978 17.2993 1.71978 16.0935V5.75634C1.71978 4.55054 2.70081 3.56952 3.9066 3.56952H11.45C11.9249 3.56952 12.3099 3.18451 12.3099 2.70962C12.3099 2.23473 11.9249 1.84973 11.45 1.84973H3.9066C1.75246 1.84973 0 3.60225 0 5.75634V16.0934C0 18.2475 1.75252 20 3.9066 20H14.3284C16.4825 20 18.235 18.2475 18.235 16.0934V8.79319C18.235 8.3183 17.85 7.9333 17.3752 7.9333Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default PenEditIcon
